'use client';

import React, { useEffect } from 'react';
import { Alert, Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { ToastTypeEnum } from './ToastTypeEnum';
import { ToastProps } from './ToastProps';

const Toast = (props: ToastProps) => {
  const computeColor = (type: ToastTypeEnum | undefined): string => {
    switch (type) {
      case ToastTypeEnum.SUCCESS:
        return 'success';
      case ToastTypeEnum.DANGER:
        return 'danger';
      case ToastTypeEnum.WARNING:
        return 'warning';
      default:
        return 'warning';
    }
  };

  useEffect(() => {
    if (props.duration) {
      const timer = setTimeout(() => {
        props.onClose();
      }, props.duration);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="meg_toast">
      <Alert color={computeColor(props.type)} isOpen={props.open}>
        <div
          className={
            'd-flex align-items-center justify-content-center py-1 ' + computeColor(props.type)
          }
        >
          <Row>
            <Col>
              <Row
                className={`text-center justify-content-center ${
                  (props?.actions?.length ?? 0) > 0 ? 'pb-2' : 'pb-1'
                }`}
              >
                <Col xs="auto">
                  <span>{props.message}</span>
                </Col>
              </Row>
              {props.actions?.map((action, index) => (
                <Row
                  key={'toast_action_' + index}
                  className="text-center no-gutters justify-content-center py-1"
                >
                  <Col xs="auto">
                    <Button className="action-button pr-1 py-1" onClick={action.onClick}>
                      {action.text}
                    </Button>
                  </Col>
                </Row>
              ))}
            </Col>
            <Col xs="auto">
              <button
                className="toast__button align-self-start text-black text-decoration-none"
                onClick={props.onClose}
              >
                <FontAwesomeIcon icon={faClose} size="lg" />
              </button>
            </Col>
          </Row>
        </div>
      </Alert>
    </div>
  );
};

export default Toast;
